import React from 'react';

const fmtDiaMes = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : '—');

// Códigos largos de solicitud interna se abrevian: KOL…114254
const abreviar = (codigo) => (codigo && codigo.length > 12 ? `${codigo.slice(0, 3)}…${codigo.slice(-6)}` : codigo);

const textoEdad = (dias) => {
    if (dias === null || dias === undefined) return 'solicitud';
    if (dias <= 0) return 'solicitud de hoy';
    return `solicitud hace ${dias} ${dias === 1 ? 'día' : 'días'}`;
};

// Tarjeta de una PI de la alerta "PI sin booking": de quién es el pendiente y qué hacer a continuación.
const TarjetaPiSinBooking = ({ item, onCrearSolicitud, onSolicitarBooking }) => {
    const vencida = item.dias < 0;
    const columnas = 3 + (item.comercial ? 1 : 0) + (item.logistica ? 1 : 0);

    return (
        <div className="ap-card">
            <div className="d-flex justify-content-between align-items-start gap-2">
                <span className="ce-mono fw-bold">{item.id_pi}</span>
                <span className="ap-pills">
                    {item.comercial && <span className="ce-pill ce-pill--sin">Comercial · sin solicitud</span>}
                    {item.logistica && <span className="ce-pill ce-pill--confirmado">Logística · {textoEdad(item.dias_solicitud)}</span>}
                </span>
            </div>
            <div className="fw-semibold my-1">{item.cliente || '—'} → {item.pod || '—'}</div>

            <div className="ap-datos" style={{ gridTemplateColumns: `repeat(${columnas}, minmax(0, 1fr))` }}>
                <div><span>Saldo HC</span><strong className="ce-mono">{item.saldo}</strong></div>
                <div><span>ETD obj.</span><strong className="ce-mono">{fmtDiaMes(item.etd_objetivo)}</strong></div>
                <div>
                    <span>{vencida ? 'Vencido' : 'Faltan'}</span>
                    <strong className="ce-mono">
                        {vencida ? `hace ${-item.dias} ${-item.dias === 1 ? 'día' : 'días'}` : `${item.dias} ${item.dias === 1 ? 'día' : 'días'}`}
                    </strong>
                </div>
                {item.logistica && (
                    <div>
                        <span>Solicitud</span>
                        <strong className="ce-mono">
                            {item.solicitudes.length > 0 ? abreviar(item.solicitudes[0].codigo) : '—'}
                            {item.solicitudes.length > 1 ? ` +${item.solicitudes.length - 1}` : ''}
                        </strong>
                    </div>
                )}
                {item.comercial && (
                    <div>
                        <span>OC</span>
                        <strong className="ce-mono">{item.ocs.length > 0 ? item.ocs.join(' · ') : 'Sin OC'}</strong>
                    </div>
                )}
            </div>

            <div className="ap-acciones">
                {item.comercial && (
                    <button type="button" className="ui-btn ui-btn-primary" onClick={() => onCrearSolicitud(item.id_proforma)}>
                        Crear solicitud
                    </button>
                )}
                {item.logistica && (
                    <button
                        type="button"
                        className={`ui-btn ${item.comercial ? 'ui-btn-secondary' : 'ui-btn-primary'}`}
                        onClick={onSolicitarBooking}
                    >
                        Solicitar booking
                    </button>
                )}
            </div>
        </div>
    );
};

export default TarjetaPiSinBooking;
